import * as fieldModel from '../field';
import getDefaultValue from '../../constants/default_values';
import getFieldByName from './get_field_by_name';

/**
 * Returns a value for a particular form field
 */
export default function getFieldValueByName(form, name) {
  const formField = getFieldByName(form, name);
  if (formField == null) { return getDefaultValue(name); }
  return fieldModel.processField(formField);
}



// WEBPACK FOOTER //
// ./client/app/scripts/leadform/models/form/get_field_value_by_name.js